import React, { useContext } from 'react';
import { IEditDishContext, EditDishContext } from '../../../../../editDishState/editDishContext';
import { Form } from 'antd';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

export const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow } = useContext<IEditDishContext>(EditDishContext);

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
